// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"centimeter"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9 19H3C2.44772 19 2 18.5523 2 18V6C2 5.44772 2.44772 5 3 5H9","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M22 19V6C22 5.44772 21.5523 5 21 5L17 5M17 5L17 19M17 5L12 5L12 19","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CentimeterIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'centimeter',
    ref,
    icon: element,
  },
));

CentimeterIcon.displayName = 'CentimeterIcon';

export default CentimeterIcon;
